var UserRole;
(function (UserRole) {
    UserRole["deactivated"] = "deactivated";
    UserRole["user"] = "user";
    UserRole["manager"] = "manager";
    UserRole["admin"] = "admin";
    UserRole["superAdmin"] = "super-admin";
})(UserRole || (UserRole = {}));
export default UserRole;
